import {createAsyncThunk} from '@reduxjs/toolkit';
import apiInstance from '../../Apis/Axios';

const serviceName = "foodie-menu-service";
const endPoint = "meal-times";

export const GetMealTimeById = createAsyncThunk('mealTime/GetMealTimeById', async (params, { dispatch, getState }) => {
    const response = await apiInstance.get(`${serviceName}/v1/${endPoint}/by-id/${params}`).then((response) => {
        return response;
    })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const CreateMealTime = createAsyncThunk("mealTime/CreateMealTime",async (params, { dispatch, getState }) => {

    const response = await apiInstance.post(`${serviceName}/v1/${endPoint}/create`, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const UpdateMealTime = createAsyncThunk("mealTime/UpdateMealTime",async (params, { dispatch, getState }) => {

    const response = await apiInstance.put(`${serviceName}/v1/${endPoint}/update`, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});
